module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-form"
  }, [_c('div', {
    staticClass: "text-center logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLogo || '/static/img/logo/logo.png'
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.formData && _vm.formData.title ? _vm.formData.title : 'login/title')))]), _vm._v(" "), (_vm.form_ErrorMessage) ? _c('div', [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.form_ErrorMessage)),
      expression: "localeFtc(form_ErrorMessage)"
    }],
    staticClass: "alert alert-danger w5-error-block",
    staticStyle: {
      "padding": "10px",
      "margin": "20px 0 20px"
    },
    attrs: {
      "role": "alert"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.softReloadApp($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/update')))])]) : _vm._e(), _vm._v(" "), (_vm.formData) ? _c('form', {
    staticClass: "w5-from",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, [_vm._l((_vm.formData.fields), function(row, index) {
    return _c('div', {
      key: index,
      staticClass: "w5-form-row"
    }, [(row && row.length) ? [_vm._l((row), function(field) {
      return [(field._field_name == 'remember_me') ? [(!_vm.is_admin) ? _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field,
          "disabled": _vm.isInputDisabled
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _vm._e()] : _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        staticStyle: {
          "padding": "10px 0"
        },
        attrs: {
          "isVisibleRow": field._visible,
          "Field": field,
          "disabled": _vm.isInputDisabled
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onFormFieldChanged(field, _vm.formData)
          },
          "blur": function($event) {
            return _vm.onFormBlur(field, _vm.formData)
          },
          "focus": function($event) {
            return _vm.onFormFocus(field, _vm.formData)
          },
          "enterKeyDown": _vm.onFormEnterKeyDown
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })] : _vm._e()], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-field text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [(_vm.form_Loading) ? _c('img', {
    attrs: {
      "src": "/static/img/loading32.gif"
    }
  }) : _c('button', {
    ref: "button",
    staticClass: "btn btn-submit btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/enter')))])])], 2)]) : _c('div', {
    style: (_vm.form_ErrorMessage ? 'height: 0' : 'height: 195px')
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData && !_vm.form_Loading && !_vm.form_ErrorMessage),
      expression: "formData && !form_Loading && !form_ErrorMessage"
    }],
    staticClass: "w5-field"
  }, [_c('router-link', {
    staticClass: "pull-left",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('page/user_register')))]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/forget"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('login/forgot')))])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2FADialogModal),
      expression: "show2FADialogModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container narrow",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hide2FADialogModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.fields2FA && _vm.fields2FA.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.fields2FA.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        ref: field._field_name,
        refInFor: true,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "fieldInModal": true,
          "removeRightPadding": true,
          "crud": "twofa",
          "action": "check",
          "Field": field
        },
        on: {
          "focus": function($event) {
            return _vm.onFocus2FA(field)
          },
          "enterKeyDown": _vm.submit2FAForm
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }), 1) : _vm._e()
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit",
    on: {
      "click": _vm.submit2FAForm
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('twofa/check')))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-602c2ee0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Login.vue
// module id = 444
// module chunks = 0